import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from './_layout/header/header.component';
import { ToastModule } from 'primeng/toast';
import { ToasterPositionEnum } from './shared/enums-interfaces';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    standalone: true,
    imports: [HeaderComponent, RouterOutlet, ToastModule],
})
export class AppComponent {
    readonly toasterPositions = ToasterPositionEnum;
}
